import { RAN_DB_CREATE_SITE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const createSingleSiteRanDb = async (form, isFtts = false) => {
  try {
    const response = await apiClient.post(RAN_DB_CREATE_SITE, form, {
      params: isFtts ? { ftts: true } : {},
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
